import styled from 'styled-components';

export const PostcodeAndCityWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: var(--gap);
`;
